export default __webpack_public_path__ + "6a08e2dc7349aa8a5c798cd8364d2544.svg";